import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Mutation } from 'react-apollo';

import EmptyUser from '../change-user-48.png';
import Logout from './logout-24.png';
import { deleteUser, deleteReceiver, changeTheme } from '../../../../actions';
import { UPDATE_USER_STATE_AND_LAST_DISCONNECTION, UPDATE_USER_THEME } from '../../../../query/queries';

import styles from './UserCardLogged.css';

const mapDispatchToProps = dispatch => {
  return {
    deleteUser: () => dispatch(deleteUser()),
    deleteReceiver: () => dispatch(deleteReceiver()),
    changeTheme: theme => dispatch(changeTheme(theme)),
  };
};

const ConnectedUserCardLogged = withRouter(class ConnectedUserCardLogged extends React.Component {

  logout = (updateUser) => () => {
    this.props.deleteUser();
    this.props.deleteReceiver();
    const state = 'OFFLINE';
    const lastDisconnection = new Date();
    const id = this.props.user.id;
    updateUser({ variables: { state, lastDisconnection, id } });
    this.props.history.push('/');
  }

  updateTheme = (updateUser) => () => {
    const oldTheme = this.props.user.theme;
    let theme = 'LIGHT';
    if (oldTheme === 'LIGHT') {
      theme = 'DARK';
    }
    this.props.changeTheme(theme);
    const id = this.props.user.id;
    updateUser({ variables: { theme, id } });
  }

  render() {
    let mainContainerTheme = '';
    if (this.props.user.theme === 'DARK') {
      mainContainerTheme = styles.mainContainerDarkTheme;
    }
    return (
      <div className={[styles.mainContainer, mainContainerTheme].join(' ')} onClick={this.saveReceiver}>
        {this.props.user.photoUrl ?
          <img src={this.props.user.photoUrl} alt='' className={styles.photo} /> :
          <img src={EmptyUser} alt='' className={styles.photo} />
        }
        <div className={styles.infoContainer}>
          <label className={styles.username}>{this.props.user.username}</label>
          <Mutation mutation={UPDATE_USER_THEME}>
            {updateUser => (
              <label
                onClick={this.updateTheme(updateUser)}
                className={styles.changeTheme}>
                Cambiar tema
               </label>
            )}
          </Mutation>
          <Mutation mutation={UPDATE_USER_STATE_AND_LAST_DISCONNECTION}>
            {updateUser => (
              <div className={styles.logout} onClick={this.logout(updateUser)}>
                <img src={Logout} alt='logout' />
              </div>
            )}
          </Mutation>
        </div>
      </div>
    )
  }
})

const UserCardLogged = connect(null, mapDispatchToProps)(ConnectedUserCardLogged);

export default UserCardLogged;


// WEBPACK FOOTER //
// ./src/pages/chat/conversations/user-card-logged/UserCardLogged.jsx